import { Collapse } from 'antd';
import clx from 'classnames';
import { darken, lighten } from 'polished';
import type * as React from 'react';
import { TbChevronDown, TbEye } from 'react-icons/tb';
import styled from 'styled-components';
import { FlexRow } from '../row/FlexRow.tsx';

const StyledCollapse = styled(Collapse)`
  &&& {
    border: 1px solid ${props => darken(0.1, props.theme.colorBgLayout)};
    border-radius: 8px;
    background: transparent;

    > .ant-collapse-item {
      border-bottom: 0;
      >.ant-collapse-content {
        border-color: ${props => darken(0.1, props.theme.colorBgLayout)};
      }
      &:last-child >.ant-collapse-content {
        border-radius: 0 0 7px 7px;
      }

      > .ant-collapse-header {
        background-color: ${props => lighten(0.015, props.theme.colorBgLayout)};
        border-radius: 7px;
        padding: 8px 12px;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0.02em;
        color: ${props => props.theme.colorTextTertiary};
        user-select: none;
      }

      > .ant-collapse-content > .ant-collapse-content-box {
        padding: 12px;
      }
      
    }
  }
`;

const ExpandIcon = styled(TbChevronDown)`
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);

  &.active {
    transform: rotate(180deg);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${props => props.theme.colorTextTertiary};
  margin-right: 8px;
  font-size: 24px;
`;

function CollapseExpandIcon({ isActive }: { isActive?: boolean }) {
  return (
    <ExpandIcon
      aria-hidden="true"
      size={18}
      className={clx({ active: isActive })}
    />
  );
}

export interface ConfigurationPreviewCardProps {
  children: React.ReactNode;
}

/**
 * Card di anteprima collassabile basata su Collapse di Ant Design.
 * L'intera barra del titolo è cliccabile per aprire/chiudere.
 * Accessibilità (aria-expanded, keyboard navigation) gestita nativamente da Collapse.
 */
export function ConfigurationPreviewCard(props: ConfigurationPreviewCardProps) {
  const { children } = props;
  return (
    <StyledCollapse
      ghost={false}
      expandIconPosition="end"
      defaultActiveKey={'preview'}
      expandIcon={CollapseExpandIcon}
      items={[
        {
          key: 'preview',
          label: (
            <FlexRow
              left={
                <IconWrapper aria-hidden="true">
                  <TbEye />
                </IconWrapper>
              }
            >
              ANTEPRIMA
            </FlexRow>
          ),
          children,
        },
      ]}
    />
  );
}
